import { showNotification } from "./functions";

export function checkMaterialRows() {
  const containers = ["yarn-container", "sequins-container"];
  let isValid = true;

  containers.forEach((containerId) => {
    const container = document.getElementById(containerId);
    if (!container) return;

    const rows = container.querySelectorAll(".editor-form__subrow");

    rows.forEach((row) => {
      const materialInput = row.querySelector(".custom-material");
      const numberInput = row.querySelector(".custom-number");

      // Function to reset border when user types
      const resetBorder = (event) => {
        event.target.style.borderBottom = "";
      };

      // Attach event listeners to reset border when user types
      [numberInput].forEach((input) => {
        if (input) {
          input.removeEventListener("input", resetBorder); // Prevent duplicate listeners
          input.addEventListener("input", resetBorder);
        }
      });

      // If Material has a value, Type and No must also have values
      if (materialInput && materialInput.value.trim() !== "") {
        if (!numberInput || numberInput.value.trim() === "") {
          isValid = false;

          // Highlight empty fields
          if (numberInput && numberInput.value.trim() === "") numberInput.style.borderBottom = "1px solid red";

          showNotification("error", "Please check the yarn and sequins fields.", 3000);
        }
      }
    });
  });

  return isValid;
}
